// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const EventLeadType = {
  Wedding: {
    Name: 'Wedding',
    Value: 'wedding',
  },
  FuneralMemorial: {
    Name: 'Funeral Memorial',
    Value: 'funeral_memorial',
  },
  CorporateEvent: {
    Name: 'Corporate Event',
    Value: 'corporate_event',
  },
  Birthday: {
    Name: 'Birthday',
    Value: 'birthday',
  },
  Anniversary: {
    Name: 'Anniversary',
    Value: 'anniversary',
  },
  BabyShower: {
    Name: 'Baby Shower',
    Value: 'baby_shower',
  },
  HolidayEvent: {
    Name: 'Holiday Event',
    Value: 'holiday_event',
  },
  JustBecause: {
    Name: 'Just Because',
    Value: 'just_because',
  },
  Other: {
    Name: 'Other',
    Value: 'other',
  },
} as const

export type EventLeadTypeValue = (typeof EventLeadType)[keyof typeof EventLeadType]['Value']
